import React from "react";
import { PropagateLoader } from "react-spinners";

const WithdrawRequestTable = ({
  isLoading,
  withdrawRequestList,
  setWithdrawStatusChangeModalOpen,
  setStatusFlag,
}) => {
  return (
    <>
      <div className="overflow-x-auto">
        <table className="w-full border border-1 rounded-xl min-w-[800px]">
          <thead className="bg-gray-50  rounded-t-xl">
            <tr>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                No.
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                <p className="flex items-center gap-1">Date</p>
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                <p className="flex items-center gap-1">Name</p>
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                <p className="flex items-center gap-1">Email</p>
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                <p className="flex items-center gap-1">Requested Amount</p>
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                <p className="flex items-center gap-1">Transferable Amount</p>
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="7" className="pt-5 pb-7 justify-items-center">
                  <PropagateLoader color="#284184" loading={true} size={10} />
                </td>
              </tr>
            ) : withdrawRequestList?.length === 0 ? (
              <tr>
                <td colSpan="6" className="pt-5 pb-7 text-center w-full">
                  No record found!
                </td>
              </tr>
            ) : (
              withdrawRequestList?.map((data) => (
                <tr key={data.id} className="border-b hover:bg-gray-50">
                  <td className="py-4 px-4 text-base">{data.id}</td>
                  <td className="py-4 px-4 text-base">
                    {data.requested_date.slice(0, 16)}
                  </td>
                  <td className="py-4 px-4 text-base">{data.name}</td>
                  <td className="py-4 px-4 text-base">{data.email}</td>
                  <td className="py-4 px-4 text-base">{data.amount}</td>
                  <td className="py-4 px-4 text-base">
                    {(data.amount * 0.97).toFixed(2)}
                  </td>
                  <td className="py-4 px-4 text-base">
                    {data?.status === "Pending" ? (
                      <>
                        <button
                          className="text-white bg-[#00A651] rounded-xl border mr-4 px-4 pt-1 pb-2"
                          onClick={() => {
                            setWithdrawStatusChangeModalOpen(true);
                            setStatusFlag({
                              status: "Approve",
                              id: data.id,
                              confirmStatus: 1,
                            });
                          }}
                        >
                          Approve
                        </button>
                        <button
                          className="text-white bg-[#F04438] rounded-xl border px-4 pt-1 pb-2"
                          onClick={() => {
                            setWithdrawStatusChangeModalOpen(true);
                            setStatusFlag({
                              status: "Reject",
                              id: data.id,
                              confirmStatus: 2,
                            });
                          }}
                        >
                          Reject
                        </button>
                      </>
                    ) : data?.status === "Approved" ? (
                      <p className="text-[#00A651]">Approved</p>
                    ) : (
                      <p className="text-[#F04438]">Rejected</p>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default WithdrawRequestTable;
